import React, { useState } from "react";
import { pluckYearArray } from "../utils";

const Accordion = ({ data, position, trophyHeaders }) => {
  const [isActive, setIsActive] = useState(false);
  const { image, display_title } = data;

  return (
    <div className="accordion-item">
      <div className="accordion-title" onClick={() => setIsActive(!isActive)}>
        <div className="leader-number">{position}</div>
        <img src={image} aria-hidden="true" width="80" />
        <div className="title">{display_title}</div>
        <div className="leader-icon">
          {isActive ? (
            <i className="fa fa-solid fa-angle-up arrow-right" />
          ) : (
            <i className="fa fa-solid fa-angle-right arrow-right" />
          )}
        </div>
      </div>
      {isActive && (
        <div className="accordion-content">
          {trophyHeaders.map((header, index) => (
            <span className={`content-${index}`} key={index}>
              {header}: <span className="value">{pluckYearArray(data)[index]}</span>
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

export default Accordion;
